import IID from '../../types/IID';
import ProjectJobMatchQuestionnaire from './jobMatch/ProjectJobMatchQuestionnaire';
import AdminProjectPhase from './project/AdminProjectPhase';
import ProjectAdminType from './ProjectAdminType';

export default interface IAdminProject extends IID {
    name: string;
    type: number;
    chart: object;
    createdDate: string;
    phase: AdminProjectPhase;
    selectedQuestionnaires: ProjectJobMatchQuestionnaire[];
    enableProjectName: boolean;
    enableResults: boolean;
    enableAdditionalDescription: boolean;
    note?: string;
    locales?: string[];
    allowedLocales: string[];
    config?: { level?: string; unit?: string; position?: string };
    consentText: string;
    primaryLanguage: string;
    comparative: boolean;
    statistics: any;
    level?: string;
    unit?: string;
    position?: string;
    participantStatistics: ParticipantStatistic[];
    state: ProjectState;
    administrators: ProjectAdminType[];
    canEdit?: boolean;
    canChangeArchiveState?: boolean;
}

export interface ParticipantStatistic {
    category: string;
    value: number;
    color: string;
}

export const ProjectStates = {
    Default: 1,
    Archived: 0,
} as const;

export type ProjectState = (typeof ProjectStates)[keyof typeof ProjectStates];
